import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ArtistAlbumsTask extends AbstractRequestTask {
  constructor(params, headers) {
    super();
    this._config = getAppConfig();
    this._headers = headers;
    this._params = {
      ...params,
    };
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    return true;
  }

  getUrl() {
    return `${this._config.end_point_music}/middleware/artist/artistAlbums/`;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = '1.0.0';
    return { ...params, ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default ArtistAlbumsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/ArtistAlbumsTask.js